module.exports = __webpack_public_path__ + "static/media/Kiosk-Screen3.752483e9.png";